import { render, staticRenderFns } from "./SettingUrlEdit.vue?vue&type=template&id=39c26424"
import script from "./SettingUrlEdit.vue?vue&type=script&lang=js"
export * from "./SettingUrlEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports